"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectDateHeadersOption')(function selectDateHeadersOption(isDateHeadersEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isDateHeadersEnabled;
}));
//# sourceMappingURL=selectDateHeadersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/actions/selectDateHeadersOption.js
// module id = 5082
// module chunks = 2